import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiKitModule } from '@serviceplan/ui-kit';
import { AssetUIModel, ClientCoreModule, ClientEnvironment, ENVIRONMENT, accessAsset } from '@thehubz/client/core';
import { Asset, AssetAspectRatio } from '@thehubz/client/data-access-api';
import { FileUploadService } from '@thehubz/client/file-upload';
import { AnyType } from '@thehubz/shared/model';
import { ReplaySubject, Subscription } from 'rxjs';
import { AssetCommonService } from './../../../../../services/asset-common.service';

@Component({
  selector: 'thehubz-aspect-ratio-view',
  templateUrl: './aspect-ratio-view.component.html',
  styleUrls: ['./aspect-ratio-view.component.scss'],
  standalone: true,
  imports: [CommonModule, ClientCoreModule, UiKitModule],
})
export class AspectRatioViewComponent implements OnInit, OnDestroy {
  @Input() aspectRatioData!: ReplaySubject<AssetUIModel>;
  @Input() changeSelection!: ReplaySubject<string | undefined>;
  // send event from child component to its parent component
  @Output() clickUpdateTableData = new EventEmitter<AnyType>();
  @Output() deleteAspectRatio = new EventEmitter<string>();

  private subscription?: Subscription;
  private changeSubscription?: Subscription;
  private aspectRatio?: string;

  assetFileData?: AnyType;
  assetData!: AssetUIModel;
  AccessAsset = accessAsset;

  constructor(
    protected assetCommonService: AssetCommonService,
    @Inject(ENVIRONMENT) private readonly env: ClientEnvironment,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.aspectRatio = params['aspectRatio'];
    });
  }

  ngOnInit(): void {
    this.changeSubscription = this.changeSelection.subscribe((aspect) => {
      this.aspectRatio = aspect;
    });

    this.subscription = this.aspectRatioData.subscribe((asset: AssetUIModel) => {
      this.assetData = asset;
      if (this.assetData && this.assetData.currentVersion) {
        this.assetFileData = asset.currentVersion;
        this.assetFileData.aspectRatios?.forEach((aspectRatio: AnyType, index: number) => {
          // file format should not be decided here, better move to the service
          let assetFileFormat = 'gen-thumbnail.webp';
          if (asset.assetType === Asset.AssetTypeEnum.Video) {
            assetFileFormat = 'gen-thumbnail.0000000.jpg';
          } else if (asset.assetType === Asset.AssetTypeEnum.HtmlBanner) {
            assetFileFormat = 'gen-preview/' + asset.mainFile.fallbackImg;
          } else if (
            asset.assetType === Asset.AssetTypeEnum.Audio ||
            asset.assetType === Asset.AssetTypeEnum.PowerpointPresentation ||
            asset.assetType === Asset.AssetTypeEnum.Other
          ) {
            // no preview
            return;
          }

          aspectRatio.currentPreviewUrl =
            this.env.fileAccessUrl + '/' + FileUploadService.getKeyForAspectRatio(this.assetData, aspectRatio.aspectRatio, assetFileFormat);

          if (this.aspectRatio) {
            if (this.aspectRatio === aspectRatio.aspectRatio) {
              aspectRatio.selected = true;
            }
          } else if (index === 0) {
            aspectRatio.selected = true;
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.changeSubscription?.unsubscribe();
  }

  emitAspectRatio(aspectRatio: AssetAspectRatio) {
    this.addRouteParam(aspectRatio.aspectRatio);
    this.selectAspectRatio(aspectRatio);
  }

  deleteAspect(aspectRatio: AssetAspectRatio) {
    this.deleteAspectRatio.emit(aspectRatio.aspectRatio);
  }

  private selectAspectRatio(aspectRatio: AssetAspectRatio) {
    this.assetFileData.aspectRatios?.forEach((ratio: AnyType) => {
      ratio.selected = false;
      if (ratio.aspectRatio === aspectRatio.aspectRatio) {
        ratio.selected = true;
      }
    });
    this.clickUpdateTableData.emit(aspectRatio);
  }

  private addRouteParam(aspectRatio: string) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { aspectRatio },
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }
}
